var _defs, _circle, _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 212 162",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n      }\n\n      .cls-3, .cls-4 {\n        fill: #fff;\n      }\n\n      .cls-5 {\n        fill: #e0e4e9;\n      }\n\n      .cls-4, .cls-2 {\n        stroke: #637b93;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 108.44,
    cy: 81,
    r: 76.54
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M69.33,113.88v-43.82c0-21.93,17.95-40.3,39.87-39.88s38.35,17.76,38.35,39.11v44.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M69.33,113.88v-43.82c0-21.93,17.95-40.3,39.87-39.88,21.25,.41,38.35,17.76,38.35,39.11v44.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M131.84,110.35c-3.7,0-6.7-2.99-6.7-6.7v-8.85h-33.37v8.85c0,3.7-2.99,6.7-6.7,6.7-20.36,0-36.87,16.5-36.87,36.87h0c0,1.11,.9,2.01,2.01,2.01h116.49c1.11,0,2.01-.9,2.01-2.01h0c0-20.36-16.5-36.87-36.87-36.87h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M134.64,68.82c-4.71-2.65-9.7-6.61-15.32-11.45-4.07-3.5-7.44-7-10.2-10.2-4.97,4.45-10.63,9.06-17.01,13.6-3.48,2.49-6.88,4.74-10.2,6.8-2.91,23.51,13.39,40.81,26.49,40.81s29.86-15.78,27.56-38.91l-1.31-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.06,110.35c.38,.74,7.23,13.34,21.5,14.36,10.33,.74,20.29-4.92,25.28-14.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M85.06,110.35c.38,.74,7.23,13.34,21.5,14.36,10.33,.74,20.29-4.92,25.28-14.36"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M159.93,89.32c.32-1.04,1.01-1.92,1.94-2.49,1.84-1.09,3.56-2.39,5.11-3.87,.61-.59,1.38-.98,2.21-1.15,.83-.16,1.69-.09,2.48,.22l3.69,1.48c3.85-5.08,6.27-11.1,6.98-17.44l-3.69-1.48c-.78-.32-1.46-.86-1.95-1.55-.49-.69-.77-1.51-.81-2.35-.1-2.14-.45-4.26-1.02-6.33-.28-1.04-.17-2.14,.3-3.11,.47-.96,1.28-1.72,2.27-2.14l6.1-2.62c.57-.24,1.17-.36,1.79-.36,.61,0,1.22,.14,1.78,.4,.56,.25,1.06,.62,1.47,1.08,.41,.46,.72,1,.91,1.58,2.03,6.58,2.48,13.54,1.31,20.32-1.02,6.26-3.4,12.21-6.98,17.44-3.82,5.69-8.92,10.41-14.89,13.77-.54,.29-1.14,.47-1.75,.52-.61,.05-1.23-.03-1.81-.24-.58-.2-1.11-.53-1.56-.95-.45-.42-.81-.93-1.05-1.5l-2.62-6.1c-.45-.99-.53-2.11-.21-3.14Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M54.59,63.51c0-1.87-1.53-3.4-3.4-3.4H23.98c-1.87,0-3.4,1.53-3.4,3.4m34.02,0v20.41c0,1.87-1.53,3.4-3.4,3.4H23.98c-1.87,0-3.4-1.53-3.4-3.4v-20.41m34.02,0l-17.01,11.91-17.01-11.91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1);
export default __webpack_public_path__ + "static/media/step-1.a17af14659867c81b016315c6f33ad99.svg";
export { ForwardRef as ReactComponent };